var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRemote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.93,13.81c-1.62,0-2.95,1.33-2.95,2.97s1.32,2.97,2.95,2.97,2.94-1.33,2.94-2.97-1.32-2.97-2.94-2.97Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.09,29.24c-1.65,.14-3.04,1.06-4.06,2.01h9.31c-1.82-1.47-3.58-2.16-5.25-2.01Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39,7.46H9c-1.1,0-2,.9-2,2V29.25c0,1.1,.9,2,2,2h4.83c.6-.94,3.77-5.55,8.92-5.99,3.81-.32,7.58,1.67,11.21,5.93l-.08,.07h5.13c1.1,0,2-.9,2-2V9.46c0-1.1-.9-2-2-2Zm-15.07,16.29c-3.83,0-6.95-3.13-6.95-6.97s3.12-6.97,6.95-6.97,6.94,3.13,6.94,6.97-3.12,6.97-6.94,6.97Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39,3.46H9c-3.31,0-6,2.69-6,6V29.25c0,3.31,2.69,6,6,6h13v5.29H8.35c-1.1,0-2,.89-2,2s.9,2,2,2h31.29c1.1,0,2-.89,2-2s-.9-2-2-2h-13.65v-5.29h13c3.31,0,6-2.69,6-6V9.46c0-3.31-2.69-6-6-6ZM19.03,31.25c1.02-.94,2.41-1.87,4.06-2.01,1.67-.15,3.43,.54,5.25,2.01h-9.31Zm21.97-2c0,1.1-.9,2-2,2h-5.13l.08-.07c-3.63-4.26-7.39-6.25-11.21-5.93-5.15,.45-8.32,5.05-8.92,5.99h-4.83c-1.1,0-2-.9-2-2V9.46c0-1.1,.9-2,2-2h30c1.1,0,2,.9,2,2V29.25Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93,9.81c-3.83,0-6.95,3.13-6.95,6.97s3.12,6.97,6.95,6.97,6.94-3.13,6.94-6.97-3.12-6.97-6.94-6.97Zm0,9.94c-1.62,0-2.95-1.33-2.95-2.97s1.32-2.97,2.95-2.97,2.94,1.33,2.94,2.97-1.32,2.97-2.94,2.97Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemote);
export default __webpack_public_path__ + "static/media/ico-remote.86463f08a17716c44daa9b36380cfdcf.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;